class MobileNav {
  constructor(node) {
    this.node = node;
    this.mobileNav = document.querySelector('.js-mobile-nav');

    this.handleBurgerButtonClick = this.handleBurgerButtonClick.bind(this);

    $(this.node).click(this.handleBurgerButtonClick);
  }

  handleBurgerButtonClick() {
    document.body.classList.toggle('mobile-nav-body');
    document.body.classList.toggle('body--mobile-nav-visible');
    this.node.classList.toggle('is-active');
    this.mobileNav.classList.toggle('visible');

    $('.js-search')[0].classList.remove('visible');
    $('.js-search-button')[0].classList.remove('is-active');
  }
}

export default () => {
  const $burgerButton = document.querySelector('.js-burger-button');

  if (!$burgerButton) {
    return;
  }

  new MobileNav($burgerButton);
}


// WEBPACK FOOTER //
// ./assets/scripts/components/mobile-nav.js